import React, { useState, useRef } from 'react';

const VOICES_LANG = {
  fr: ['fr-FR', 'fr-BE', 'fr-CA'],
  en: ['en-US', 'en-GB', 'en-AU'],
  es: ['es-ES', 'es-MX', 'es-US'],
  de: ['de-DE', 'de-AT'],
  pt: ['pt-BR', 'pt-PT'],
  it: ['it-IT'],
  ar: ['ar-SA', 'ar-EG'],
  ja: ['ja-JP'],
  original: ['fr-FR', 'en-US'],
};

export default function TTSBar({ text, lang = 'fr', label = '🔊 Écouter', inline = false }) {
  const [playing, setPlaying] = useState(false);
  const [speed, setSpeed] = useState(1);
  const uttRef = useRef(null);

  const supported = 'speechSynthesis' in window;

  const speak = () => {
    if (!supported || !text) return;
    window.speechSynthesis.cancel();

    const utt = new SpeechSynthesisUtterance(text);
    const voices = window.speechSynthesis.getVoices();
    const langs = VOICES_LANG[lang] || ['fr-FR'];

    let voice = null;
    for (const l of langs) {
      voice = voices.find(v => v.lang.startsWith(l.split('-')[0]));
      if (voice) break;
    }
    if (voice) utt.voice = voice;
    utt.rate = speed;
    utt.pitch = 1;

    utt.onstart = () => setPlaying(true);
    utt.onend = () => setPlaying(false);
    utt.onerror = () => setPlaying(false);

    uttRef.current = utt;
    window.speechSynthesis.speak(utt);
  };

  const stop = () => {
    window.speechSynthesis.cancel();
    setPlaying(false);
  };

  if (!supported) return null;

  if (inline) return (
    <button className="tts-btn" onClick={playing ? stop : speak} style={{fontSize:12}}>
      {playing ? '⏹ Stop' : '🔊'}
    </button>
  );

  return (
    <div className="tts-bar">
      <button className="tts-btn" onClick={playing ? stop : speak}>
        {playing ? '⏹ Stop' : '🔊'} {label}
      </button>
      <select
        className="lang-select"
        value={speed}
        onChange={e => setSpeed(parseFloat(e.target.value))}
        style={{width:'auto',flex:'none'}}
      >
        <option value={0.7}>Lent</option>
        <option value={1}>Normal</option>
        <option value={1.3}>Rapide</option>
        <option value={1.6}>Très rapide</option>
      </select>
    </div>
  );
}
